import { render, staticRenderFns } from "./Dig.vue?vue&type=template&id=1a60d7f0&scoped=true&lang=pug&"
import script from "./Dig.vue?vue&type=script&lang=js&"
export * from "./Dig.vue?vue&type=script&lang=js&"
import style0 from "./Dig.vue?vue&type=style&index=0&id=1a60d7f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a60d7f0",
  null
  
)

export default component.exports